/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CorsAllowedOriginEntity,
  CreateCorsAllowedOriginDto,
  ListCorsAllowedOriginResult,
  UpdateCorsAllowedOriginDto,
} from '../models/index';
import {
    CorsAllowedOriginEntityFromJSON,
    CorsAllowedOriginEntityToJSON,
    CreateCorsAllowedOriginDtoFromJSON,
    CreateCorsAllowedOriginDtoToJSON,
    ListCorsAllowedOriginResultFromJSON,
    ListCorsAllowedOriginResultToJSON,
    UpdateCorsAllowedOriginDtoFromJSON,
    UpdateCorsAllowedOriginDtoToJSON,
} from '../models/index';

export interface CreateCorsOriginsRequest {
    createCorsAllowedOriginDto: CreateCorsAllowedOriginDto;
}

export interface DeleteCorsOriginsRequest {
    id: string;
}

export interface GetCorsOriginsRequest {
    id: string;
}

export interface ListCorsOriginsRequest {
    filter?: string;
    skip?: string;
    take?: string;
}

export interface UpdateCorsOriginsRequest {
    id: string;
    updateCorsAllowedOriginDto: UpdateCorsAllowedOriginDto;
}

/**
 * 
 */
export class CorsApi extends runtime.BaseAPI {

    /**
     * 接続を許可するURLを登録します。
     */
    async createCorsOriginsRaw(requestParameters: CreateCorsOriginsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CorsAllowedOriginEntity>> {
        if (requestParameters['createCorsAllowedOriginDto'] == null) {
            throw new runtime.RequiredError(
                'createCorsAllowedOriginDto',
                'Required parameter "createCorsAllowedOriginDto" was null or undefined when calling createCorsOrigins().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/cors`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCorsAllowedOriginDtoToJSON(requestParameters['createCorsAllowedOriginDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CorsAllowedOriginEntityFromJSON(jsonValue));
    }

    /**
     * 接続を許可するURLを登録します。
     */
    async createCorsOrigins(requestParameters: CreateCorsOriginsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CorsAllowedOriginEntity> {
        const response = await this.createCorsOriginsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 接続を許可するURLを削除します。
     */
    async deleteCorsOriginsRaw(requestParameters: DeleteCorsOriginsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CorsAllowedOriginEntity>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteCorsOrigins().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/cors/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CorsAllowedOriginEntityFromJSON(jsonValue));
    }

    /**
     * 接続を許可するURLを削除します。
     */
    async deleteCorsOrigins(requestParameters: DeleteCorsOriginsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CorsAllowedOriginEntity> {
        const response = await this.deleteCorsOriginsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 接続を許可するURLを一件取得します。
     */
    async getCorsOriginsRaw(requestParameters: GetCorsOriginsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CorsAllowedOriginEntity>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getCorsOrigins().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/cors/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CorsAllowedOriginEntityFromJSON(jsonValue));
    }

    /**
     * 接続を許可するURLを一件取得します。
     */
    async getCorsOrigins(requestParameters: GetCorsOriginsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CorsAllowedOriginEntity> {
        const response = await this.getCorsOriginsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 接続を許可するURLの一覧を取得します。
     */
    async listCorsOriginsRaw(requestParameters: ListCorsOriginsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListCorsAllowedOriginResult>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['take'] != null) {
            queryParameters['take'] = requestParameters['take'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/cors`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListCorsAllowedOriginResultFromJSON(jsonValue));
    }

    /**
     * 接続を許可するURLの一覧を取得します。
     */
    async listCorsOrigins(requestParameters: ListCorsOriginsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListCorsAllowedOriginResult> {
        const response = await this.listCorsOriginsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 接続を許可するURLを更新します。
     */
    async updateCorsOriginsRaw(requestParameters: UpdateCorsOriginsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CorsAllowedOriginEntity>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateCorsOrigins().'
            );
        }

        if (requestParameters['updateCorsAllowedOriginDto'] == null) {
            throw new runtime.RequiredError(
                'updateCorsAllowedOriginDto',
                'Required parameter "updateCorsAllowedOriginDto" was null or undefined when calling updateCorsOrigins().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/cors/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCorsAllowedOriginDtoToJSON(requestParameters['updateCorsAllowedOriginDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CorsAllowedOriginEntityFromJSON(jsonValue));
    }

    /**
     * 接続を許可するURLを更新します。
     */
    async updateCorsOrigins(requestParameters: UpdateCorsOriginsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CorsAllowedOriginEntity> {
        const response = await this.updateCorsOriginsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
